import { requestType } from '~/config/enum.config';
var SERVICE = 'business-service';
var CONTROLLER = 'smsTemplateController';
export default {
    /**
     * 查询工单
     */
    findAllSmsTemplate: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'findGrades',
        type: requestType.Post
    }
};
